
import {CREATE_BREED_ATTRIBUTE ,
    UPDATE_BREED_ATTRIBUTE ,
      DELETE_BREED_ATTRIBUTE ,
      FETCH_BREED_ATTRIBUTES } from '../actions';
  
  const initialState = {
    selectedToDelete: null,
    selectedToEdit: null,
    setBreedAttribute : null ,
    updateBreedAttribute : null,
    breedAttributes: [],
    loading: false, 
    updateBreedAttributeError : null,
    setBreedAttributeError : null,
    breedAttributesError : null,
    selectedToDeleteError : null,
  };
  
  function breedAttributeReducer(state = initialState, action) {
    let selectedToDelete,
      breedAttributes,
      updateBreedAttribute,
      setBreedAttribute;
  
    switch (action.type) {
      case `${CREATE_BREED_ATTRIBUTE}_PENDING`:
      case `${UPDATE_BREED_ATTRIBUTE}_PENDING`:  
      case `${FETCH_BREED_ATTRIBUTES}_PENDING`:
      case `${DELETE_BREED_ATTRIBUTE}_PENDING`:
        return { ...state, loading: true,
          selectedToDeleteError : null,
          breedAttributesError : null,
          setBreedAttributeError : null,
          updateBreedAttributeError : null,
        };
       
  
      case `${CREATE_BREED_ATTRIBUTE}_FULFILLED`:
          setBreedAttribute = action.payload.data;
          return { ...state, loading: false, setBreedAttribute };
      case `${UPDATE_BREED_ATTRIBUTE}_FULFILLED`:
          updateBreedAttribute = action.payload.data;
          return { ...state, loading: false, updateBreedAttribute }; 
      case `${FETCH_BREED_ATTRIBUTES}_FULFILLED`:
          breedAttributes = action.payload.data;
          return { ...state, loading: false, breedAttributes };
  
      case `${DELETE_BREED_ATTRIBUTE}_FULFILLED`:
        selectedToDelete = action.payload.data;
        return { ...state, loading: false, selectedToDelete }; 
      case `${CREATE_BREED_ATTRIBUTE}_REJECTED`:
        return {...state, loading: false, setBreedAttributeError: action.payload.response.data, state: initialState };
      case `${UPDATE_BREED_ATTRIBUTE}_REJECTED`:
        return {...state, loading: false, updateBreedAttributeError: action.payload.response.data, state: initialState };
      case `${FETCH_BREED_ATTRIBUTES}_REJECTED`:
        return {...state, loading: false, breedAttributesError: action.payload.response.data, state: initialState };
      case `${DELETE_BREED_ATTRIBUTE}_REJECTED`:
        return {...state, loading: false, selectedToDeleteError: action.payload.response.data, state: initialState };
  
      default:
        return state;
    }
  }
  
  export default breedAttributeReducer;
  